export default __webpack_public_path__ + "static/media/section3_bg5.dcc04a48.png";